import { Lightning, Router } from '@lightningjs/sdk';
import { removeSplashScreen } from '../../logic/app/app.utils';
import { PrivacySettings } from './privacySettings/privacySettings.component';
import { PRIVACY_SETTINGS_EXIT_SIGNAL } from './privacySettings/privacySettings.constants';

export class Settings extends Lightning.Component {
  static _template() {
    return {
      Settings: {
        type: PrivacySettings,
        signals: {
          [PRIVACY_SETTINGS_EXIT_SIGNAL]: '_handleExitPrivacySettings',
        },
      },
    };
  }

  _active() {
    removeSplashScreen();
  }

  _handleExitPrivacySettings() {
    Router.back();
  }

  _getFocused() {
    return this.tag('Settings');
  }
}
